import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LeftMenuDataAccessModule } from "@youm-front/left-menu/data-access";
import { LeftMenuUiLeftMenuModule } from "@youm-front/left-menu/ui/left-menu";
import { UtilsCommonModule } from "@youm-front/utils/common";
import Components, { LeftMenuComponent } from "./components";

@NgModule({
  imports: [
    CommonModule,
    LeftMenuDataAccessModule,
    LeftMenuUiLeftMenuModule,
    UtilsCommonModule
  ],
  declarations: [Components],
  exports: [LeftMenuComponent]
})
export class LeftMenuFeatureLeftMenuModule {}
